import { commonParams } from "@/config/common";
import { requestJson } from "../lib/request";
import { LanguageContent } from '../lib/util/lang'
/**
 * Paas商户类，商户信息
 */
class PaasTenant{
    static id = 0
    static paas_url = `${ commonParams.PAAS_CONFIG }/config/`
    static info
    static favicon = `${commonParams.CDN_URL}${ commonParams.PAAS_CONFIG }/favicon/favicon.png`

    static async getTenantInfo(){
        if(!this.info){
            const langSuffix = LanguageContent.getPaaSJsonSuffix()
            const res = await requestJson(`${this.paas_url}tenantInfo_${langSuffix}.json`)
            if(res){
                this.info = res
                document.title = this.info.tenantName
                this.insertShortcutIcon()
                return res
            }else{
                return false
            }
        }else{
            return this.info
        }
    }
    static insertShortcutIcon() {
        const head = document.head || document.getElementsByTagName('head')[0];
        const link = document.createElement('link');
        link.rel = "shortcut icon";
        link.type = "image/x-icon";
        link.href = this.favicon + '?v=TENANTicon';
        head.appendChild(link);
    }

    static getLoginInfo(){
        return requestJson(`${this.paas_url}tenantLoginConf.json`)
    }

    static getLogo(){
        return `${commonParams.CDN_URL}${ commonParams.PAAS_CONFIG }/logo/logo.png`
    }

    static getNavList(){
        return requestJson(`${this.paas_url}cTenantMenu.json`)
    }

    static getRouters(){
        return requestJson(`${this.paas_url}cTenantPath.json`)
    }

    static getBaseInfo(){
        return requestJson(`${this.paas_url}cTenantConf.json`)
    }

    static getPageList(){
        return requestJson(`${this.paas_url}cTenantPage.json`)
    }

    static getFooter(){
        return requestJson(`${this.paas_url}cTenantFooterConf.json`)
    }

    static getNavListM(){
        return requestJson(`${this.paas_url}mTenantMenu.json`)
    }

    static getRoutersM(){
        return requestJson(`${this.paas_url}mTenantPath.json`)
    }

    static getBaseInfoM(){
        return requestJson(`${this.paas_url}mTenantConf.json`)
    }

    static getPageListM(){
        return requestJson(`${this.paas_url}mTenantPage.json`)
    }

    static getFooterM(){
        return requestJson(`${this.paas_url}mTenantFooterConf.json`)
    }

    static getAgreement() {
        if (!this.agreementInfo){
            const langSuffix = LanguageContent.getPaaSJsonSuffix()
            return requestJson(`${this.paas_url}tenantLoginProtocolConf_${langSuffix}.json`)
        }else{
            return this.agreementInfo
        }
    }
}

export {
    PaasTenant
}


// WEBPACK FOOTER //
// ./src/models/paas-tenant.js